export interface RuntimeConfig {
  BASE_URL: string;
  REGISTER_WITH_EMAIL_CONFIRMATION: boolean;
  GRANT_TYPE: string;
  CLIENT_ID: string;
  CLIENT_SECRET: string;
  REACT_APP_TSDCD_API: string;
}

let runtimeConfig: RuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<void> {
  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error('Failed to load runtime config');
  }
  runtimeConfig = await response.json();
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!runtimeConfig) {
    throw new Error('Runtime config not loaded yet');
  }
  return runtimeConfig;
}